import React, { FC, useEffect, useState } from 'react';
import { Team } from '../../../../entity/Team';
import { Divider, Space, Spin, Tag, Typography } from 'antd';
import { UserAvatar, UserNameView } from '../../../../components/atoms/UserAvatar';
import './teams.less';
import { InfoView, InfoViewItem } from '../../../../components/info-view/InfoView';
import { useConnection, useEvents } from '../../../../connection/Application';

type Props = {
  value: Team;
  onEditableChanged: (editable: Team) => void;
};

export const TeamView: FC<Props> = (props) => {
  const { value, onEditableChanged } = props;
  const { id: teamId } = value;
  const [team, setTeam] = useState<Team>();
  const [loading, setLoading] = useState<boolean>(false);
  const connection = useConnection();
  const events = useEvents();

  useEffect(() => {
    const handler = (t: Team) => {
      if (t.id === teamId) {
        setTeam({ ...team, ...t });
      }
    };
    events.on('TEAM_UPDATED', handler);
    return () => {
      events.off('TEAM_UPDATED', handler);
    };
  }, [events, team, teamId]);

  useEffect(() => {
    setLoading(true);
    connection
      .get(`teams/${teamId}`)
      .then((team) => {
        const editable = { ...team };
        editable.leads = team.leads?.map((l: any) => l.id) ?? [];
        editable.members = team.members?.map((l: any) => l.id) ?? [];
        onEditableChanged(editable);
        setTeam(team);
      })
      .finally(() => setLoading(false));
  }, [onEditableChanged, connection, teamId]);

  return (
    <Spin spinning={loading}>
      <div className="teams-view">
        <Space size={24} align={'start'}>
          <UserAvatar type={'team'} size={80} src={team?.image} />
          <Space direction={'vertical'}>
            <Space>
              <Typography.Title>{team?.name}</Typography.Title>
              <Tag color={team?.teamType?.color}>{team?.teamType?.name}</Tag>
            </Space>
            <Typography.Paragraph>{team?.description}</Typography.Paragraph>
          </Space>
        </Space>
        <Divider />
        <InfoView>
          <InfoViewItem title="Leads">
            {team?.leads?.map((value1, index) => (
              <UserNameView
                src={value1.image}
                name={`${value1.firstName} ${value1.lastName}`}
                tags={true}
                key={index}
              />
            ))}
          </InfoViewItem>
          <InfoViewItem title="Parent Team">{team?.parent?.name ?? 'Not Set'}</InfoViewItem>
          <InfoViewItem fullwidth={true} title={'Members (' + (team?.members?.length ?? 0) + ')'}>
            {team?.members?.map((memo, index) => (
              <UserNameView
                name={`${memo.firstName} ${memo.lastName}`}
                src={memo.image}
                tags={true}
                key={index}
              />
            ))}
          </InfoViewItem>
        </InfoView>
      </div>
    </Spin>
  );
};
